import {
  addCurrentAuthHeader,
  type SessionService,
} from '@efdigital/ll-addon-auth';

export type LookupUsersRequestBody = {
  users: string[];
};

export type LookupUserConsent = {
  anon: boolean;
};

export type LookupUser = {
  id: string;
  consent?: LookupUserConsent;
  deleted?: boolean;
  title?: string;
  email?: string;
};

export type LookupUsersResponseBody = LookupUser[];

export async function buildLookupUsersRequest(
  userIds: string[],
  session: SessionService
): Promise<Request> {
  const body: LookupUsersRequestBody = {
    users: userIds,
  };
  const init = await addCurrentAuthHeader(
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    },
    { session }
  );

  return new Request(
    `${session.apis.monolithApi.host}/management-api/users/lookup`,
    init
  );
}

export async function parseLookupUsersResponse(
  response: Response
): Promise<LookupUsersResponseBody> {
  if (!response.ok) {
    throw new Error(`Failed to look up users: ${response.statusText}`);
  }
  return (await response.json()) as LookupUsersResponseBody;
}
